import { render, staticRenderFns } from "./saveOrUpdate.vue?vue&type=template&id=4af26d1c&scoped=true&"
import script from "./saveOrUpdate.vue?vue&type=script&lang=js&"
export * from "./saveOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./saveOrUpdate.vue?vue&type=style&index=0&id=4af26d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af26d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af26d1c')) {
      api.createRecord('4af26d1c', component.options)
    } else {
      api.reload('4af26d1c', component.options)
    }
    module.hot.accept("./saveOrUpdate.vue?vue&type=template&id=4af26d1c&scoped=true&", function () {
      api.rerender('4af26d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/country/saveOrUpdate.vue"
export default component.exports